export const identifierPrefix = 'b5bec94ecac411ec9d640242ac120002'
export const scopes = [
  'offline',
  'projects:read',
  'projects:write',
  'resources:read',
  'resources:write',
  'users:write',
  'users:read',
  'user-defined-categories:read',
  'user-defined-categories:write',
  'tasks:write',
  'tasks:read',
  'timesheets:read',
  'timesheets:write',
  'categories:read'
]
